import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { stringify } from 'qs';
import { map, Observable } from 'rxjs';
import { extractStrapiData } from '../../helpers';
import {
  Manufacturer,
  StrapiPageResponse,
  StrapiQueryParams,
} from '../../models';

@Injectable({
  providedIn: 'root',
})
export class ManufacturerService {
  private readonly http = inject(HttpClient);

  private readonly url = 'api/manufacturers';

  private readonly queryParams: StrapiQueryParams = {
    sort: ['id:asc'],
  };

  list(
    queryParams: StrapiQueryParams = this.queryParams,
    clientId?: string | null,
  ): Observable<Manufacturer[]> {
    const params = stringify(this.withClientFilter(queryParams, clientId), {
      encodeValuesOnly: true,
    });

    return this.http
      .get<StrapiPageResponse<Manufacturer>>(`${this.url}?${params}`)
      .pipe(map((response) => extractStrapiData(response)));
  }

  listWithCabinets(clientId?: string | null): Observable<Manufacturer[]> {
    return this.list(
      {
        ...this.queryParams,
        filters: {
          cabinets: {
            id: {
              $notNull: true,
            },
          },
        },
      },
      clientId,
    );
  }

  listWithRacks(clientId?: string | null): Observable<Manufacturer[]> {
    return this.list(
      {
        ...this.queryParams,
        filters: {
          $or: [
            {
              racks: {
                id: {
                  $notNull: true,
                },
              },
            },
            {
              api: {
                $eq: 'ALPHA_INDUSTRIE',
              },
            },
          ],
        },
      },
      clientId,
    );
  }

  private withClientFilter(
    queryParams: StrapiQueryParams,
    clientId?: string | null,
  ): StrapiQueryParams {
    if (!clientId) {
      return queryParams;
    }

    return {
      ...queryParams,
      filters: {
        ...(queryParams.filters ?? {}),
        clients: {
          id: { $eq: clientId },
        },
      },
    };
  }
}
